import { render, staticRenderFns } from "./StatusQuotations.vue?vue&type=template&id=0de22077&scoped=true&"
import script from "./StatusQuotations.vue?vue&type=script&lang=js&"
export * from "./StatusQuotations.vue?vue&type=script&lang=js&"
import style0 from "./StatusQuotations.vue?vue&type=style&index=0&id=0de22077&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de22077",
  null
  
)

export default component.exports